export default __webpack_public_path__ + "static/media/ic_photo_chat_list.641120b9.svg";